import { ContentSection, Heading, Icon, Paragraph } from '@vwfs-bronson/bronson-react'
import React, { FunctionComponent, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'
import { getOriginSystem } from '../../../services/common/utils'

const TransactionsConfirmedPage: FunctionComponent = () => {
  const { t, i18n } = useTranslation()
  const storefrontData = useSelector(getStorefrontData)
  const originSystem = useMemo(() => getOriginSystem(storefrontData), [storefrontData])

  return (
    <ContentSection pageWrap>
      <div className="u-text-center">
        <Icon name='semantic-success' className='u-text-success' aria-hidden="true" />
        <Heading level={1}>{t(`transactions:${originSystem}:confirmed:title`)}</Heading>
      </div>
      <Paragraph>
        {t(`transactions:${originSystem}:confirmed:subtitle:text`)}
      </Paragraph>
      {i18n.exists(
        `transactions:${originSystem}:canceled:subtitle:email`
      ) &&
        i18n.exists(
          `transactions:${originSystem}:canceled:subtitle:phone`
        ) && (
          <Paragraph>
            <span>
              {t(`transactions:${originSystem}:confirmed:subtitle:email`, {
                email: storefrontData?.customerData?.contactData?.email,
              })}
            </span>
            <br />
            <span>
              {t(`transactions:${originSystem}:confirmed:subtitle:phone`, {
                phone: `${storefrontData?.customerData?.contactData?.mobilePhoneCountryCode} ${storefrontData?.customerData?.contactData?.mobilePhoneNumber}`,
              })}
            </span>
          </Paragraph>
        )}
    </ContentSection>
  )
}

export default TransactionsConfirmedPage
